export default class Option {
    "optionId": number;
    "name": string;
    "code": string;
    "type": string;
    "optionGroupId": number;
    "ordinal": number;
    "description": string;
    "allowMultiples": boolean;
    "allowSorting": boolean;
    "sortConstraint": string;
    "configJson": string;
    "oneOnlyGroupId": string;
} 